// miércoles, 27/08/2025, 15:00
export const DATE_TIME_WEEKDAY_LONG_24H = {
  weekday: "long",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
} as const;


export const DATE_TIME_SHORT_24H = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
} as const;